function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityIndoorHotSpringFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.192 15.57c0 .607.236 1.178.666 1.607a4.279 4.279 0 010 6.042h-2.352a4.26 4.26 0 01.938-1.415 2.274 2.274 0 000-3.213 4.241 4.241 0 01-1.252-3.021c0-1.141.444-2.214 1.252-3.021h2.35c-.207.515-.52.997-.936 1.414-.43.429-.666 1-.666 1.607z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.836 21.976v-2.208c2.13.86 3.301 2.118 3.301 3.539 0 1.42-1.172 2.678-3.3 3.539-1.843.744-4.27 1.154-6.838 1.154-2.566 0-4.994-.41-6.836-1.154-2.129-.861-3.3-2.118-3.3-3.54 0-1.42 1.171-2.677 3.3-3.538v2.208c-.937.506-1.3 1.012-1.3 1.33 0 .396.536 1.073 2.05 1.685C11.523 25.64 13.683 26 16 26c2.316 0 4.48-.358 6.087-1.01 1.514-.611 2.051-1.288 2.051-1.683 0-.32-.363-.825-1.3-1.331z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.587 17.177c-.43-.43-.666-1-.666-1.607s.236-1.178.666-1.607c.417-.417.73-.9.937-1.414h-2.35a4.241 4.241 0 00-1.253 3.02c0 1.142.444 2.215 1.252 3.022a2.274 2.274 0 010 3.213 4.26 4.26 0 00-.938 1.415h2.352a4.279 4.279 0 000-6.042z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.222 13.963a2.275 2.275 0 000 3.214 4.24 4.24 0 011.252 3.02 4.241 4.241 0 01-1.252 3.022h-2.351c.208-.515.521-.998.937-1.415.43-.43.666-1 .666-1.606 0-.607-.236-1.178-.666-1.607a4.279 4.279 0 010-6.042h2.351a4.239 4.239 0 01-.937 1.414z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.045l12.038 7.18.695.416v2.327L16 6.374 3.267 13.968v-2.323l.266-.164L16 4.045z",
    fill: props.color
  }));
}

export default SvgIconFacilityIndoorHotSpringFilled;